$(function() {
    if (document.getElementById('instafeed') && typeof InstagramToken !== "undefined") {
        var feed = new Instafeed({
            target: 'instafeed',
            accessToken: InstagramToken,
            limit: 6,
            template: '<li><a href="{{link}}" target="_blank"><img src="{{image}}" alt="{{caption}}" class="thumbnail" /></a></li>'
        });
        feed.run();
    }
});